import { type FC } from 'react';
import { graphql, usePaginationFragment } from 'react-relay';

import { NftDraftItemTile } from 'dibs-nft-item-tile/exports/NftDraftItemTile';
import { NftProfileSectionLoadMore } from './NftProfileSectionLoadMore';
import { trackPdpImpression } from './nftCollectorTracking';

import styles from './NftProfileSections.scss';

import { type NftProfileSectionDrafts_viewer$key as ViewerRef } from './__generated__/NftProfileSectionDrafts_viewer.graphql';
import { type NftProfileSectionDraftsPaginationQuery as PaginationQuery } from './__generated__/NftProfileSectionDraftsPaginationQuery.graphql';

type Props = {
    viewer: ViewerRef;
};

export const NftProfileSectionDrafts: FC<Props> = ({ viewer: viewerRef }) => {
    const { data, hasNext, loadNext, isLoadingNext } = usePaginationFragment<
        PaginationQuery,
        ViewerRef
    >(
        graphql`
            fragment NftProfileSectionDrafts_viewer on Viewer
            @refetchable(queryName: "NftProfileSectionDraftsPaginationQuery") {
                drafts: nftItemDraftsByCreator(
                    username: $username
                    creatorAddress: $walletAddress
                    first: $draftsFirst
                    after: $draftsCursor
                ) @connection(key: "NftProfileSectionDrafts_drafts") {
                    edges {
                        node {
                            serviceId
                            ...NftDraftItemTile_nftItemDraft
                        }
                    }
                }
                ...NftItemTile_viewer
                ...NftDraftItemTile_viewer
            }
        `,
        viewerRef
    );

    return (
        <div className={styles.auctionSectionContainer}>
            <ul className={styles.auctionItems}>
                {data.drafts?.edges?.map((edge, index) => {
                    const nftItemDraft = edge?.node;

                    if (!nftItemDraft) {
                        return null;
                    }

                    return (
                        <li className={styles.itemTileWrapper} key={nftItemDraft.serviceId}>
                            <NftDraftItemTile
                                viewer={data}
                                nftItemDraft={nftItemDraft}
                                fireImpressionTracking={trackPdpImpression(
                                    nftItemDraft.serviceId,
                                    null,
                                    index,
                                    'CREATOR_DRAFTS_TAB'
                                )}
                            />
                        </li>
                    );
                })}
            </ul>

            <NftProfileSectionLoadMore
                hasNext={hasNext}
                isLoadingNext={isLoadingNext}
                onClick={() => loadNext(20)}
            />
        </div>
    );
};
